<template>
  <jtCard
    containerHeight="429"
    title="集装箱办理量"
    style="margin-bottom: 30px"
  >
    <div class="container">
      <div
        class="chart"
        id="containerHandler"
        style="width: 100%; height: 350px"
      ></div>
    </div>
  </jtCard>
</template>
<script>
//先导入charts
import Charts from "@jiaminghi/charts";
import jtCard from "@/components/Card";
export default {
  components: {
    jtCard,
  },
  props: {
    tbContainerHandlingVolumeList: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  mounted() {
    // let _this = this;
    // 在mouted里面做了一个立即执行函数 ，防止里面的变量污染
    (function () {
      //下面和eacharts差不多
      const container = document.getElementById("containerHandler");
      const myChart = new Charts(container);

      // console.log(documentDate);
      var option = {
        title: {
          show: false,
        },
        legend: {
          top: 40,
          left:600,
          textStyle: {
            fill: "#0EFF97",
            fontSize: 20,
          },
          data: [
            { name: "日到达", color: "#08F38F" },
            { name: "日发送", color: "#FB6224" },
          ],
        },
        xAxis: {
          // data: _this.tbContainerHandlingVolumeList.documentDate,
          data:['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
        },
        yAxis: {
          data: "value",

          axisLine: {
            style: {
              borderType: "dashed",
            },
          },
          splitLine:{
            show: false
          },
          axisLabel: {
            style: {
              fontSize: 20,
              fill: "#fff",
            },
          },
        },
        series: [
          {
            name: "日到达",
            // data: _this.tbContainerHandlingVolumeList.arrived,
            data:[820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,

            lineArea: {
              show: true,
              gradient: ["rgba(8,243,143, 0.75)", "rgba(8,243,143, 0.08)"],
            },
            lineStyle: {
              stroke: "#08F38F",
              lineWidth: 4
            },
            linePoint: {
              radius: 6,
              style: {
                fill: "#08F38F",
                stroke: "transparent",
              },
            },
          },
          {
            name: "日发送",
            // data: _this.tbContainerHandlingVolumeList.send,
            data:[822, 940,701, 834, 1090, 1330, 1020],
            type: "line",
            smooth: true,
            lineStyle: {
              stroke: "#FB6224",
              lineWidth: 4
            },
            lineArea: {
              show: true,
              gradient: ["rgba(251,98,36, 1)", "rgba(251,98,36, 0.08)"],
            },
            linePoint: {
              radius: 6,
              style: {
                fill: "#FB6224",
                stroke: "transparent",
              },
            },
          },
        ],
      };

      myChart.setOption(option);

      //图表自适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    })();
  },
  methods: {},
};
</script>
<style scoped>
.chart {
  height: 240px;
  margin-left: 15px;
}

h2 {
  height: 48px;
  color: white;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
  line-height: 48px;
}
</style>
